<template>
    <div class="form-group">
        <label v-if="label" class="form-label" :for="id">
            {{ label }}
        </label>

        <input
            :id="id"
            ref="input"
            v-bind="$attrs"
            class="form-control"
            :class="{ 'is-invalid': errors.length }"
            :type="type"
            :value="value"
            @input="$emit('input', $event.target.value)">

        <div v-if="errors.length" class="text-danger">
            <small class="font-weight-bold">
                {{ errors[0] }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        value: [String, Number],
        label: String,
        errors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
}
</script>
